
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/career/[jobId]",
      function () {
        return require("private-next-pages/career/[jobId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/career/[jobId]"])
      });
    }
  